import { WsEvent } from '@ts-ws/enums'

import { useCustomerStore } from '@stores/me/customer'

import { onDisciplineReady } from '@hooks/discipline/on-discipline-ready.hook'

export const useListenEventCustomer = (channel: any): void => {
  const customerStore = useCustomerStore()

  onDisciplineReady(() => {
    channel.listen(WsEvent.CustomerUpdated, async (): Promise<void> => {
      await customerStore.refreshNow()
    })
  })
}
